module.exports = __webpack_public_path__ + "img/host-circle.fc0aeb1c.png";